<template>
  <v-app-bar color="secondary">
    <v-app-bar-nav-icon
      variant="text"
      aria-label="Toggle navigation"
      @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <v-toolbar-title class="title">Janus4cast</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu anchor="bottom end">
      <template v-slot:activator="{ props }">
        <v-btn
          class="mr-2"
          icon="mdi-account-circle"
          aria-label="Account"
          v-bind="props"
        >
        </v-btn>
      </template>
      <v-list density="compact" class="py-0">
        <v-list-item v-if="me && me.username">
          <v-list-item-title>{{ me.username }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-avatar start class="ma-2">
            <v-icon icon="mdi-logout"></v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Log out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>

  <v-navigation-drawer
    v-if="hoverOne"
    :rail="hoverOneRail"
    :expand-on-hover="hoverOne"
    :width="272"
    class="lx-drawer"
  >
    <v-list lines="one" density="compact" class="bg-transparent">
      <template v-for="(option, i) in navOptions" :key="i">
        <v-list-subheader v-if="option.header" class="lx-nav-group">{{
          option.header
        }}</v-list-subheader>
        <v-list-item
          v-else
          :value="option.value"
          :active="isActive(option.value)"
          @click="redirectTo(option.value)"
        >
          <v-list-item-avatar start class="ma-2">
            <v-icon :icon="option.icon"></v-icon>
          </v-list-item-avatar>
          <v-list-item-title :title="option.text">
            <p class="list-title">{{ option.text }}</p>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>

  <v-navigation-drawer
    v-if="!hoverOne"
    v-model="drawer"
    :width="272"
    class="lx-drawer"
  >
    <v-list lines="one" density="compact" class="bg-transparent">
      <template v-for="(option, i) in navOptions" :key="i">
        <v-list-subheader v-if="option.header" class="lx-nav-group">{{
          option.header
        }}</v-list-subheader>
        <v-list-item
          v-else
          :value="option.value"
          :active="isActive(option.value)"
          @click="redirectTo(option.value)"
        >
          <v-list-item-avatar start class="ma-2">
            <v-icon :icon="option.icon"></v-icon>
          </v-list-item-avatar>
          <v-list-item-title :title="option.text">
            <p class="list-title">{{ option.text }}</p>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { useDisplay } from "vuetify";
export default {
  name: "AppBarUserMenu",
  data: () => ({
    drawer: true,
    group: null,
    navOptions: [
      { text: "Home", icon: "mdi-view-dashboard-outline", value: "home" },
      { header: "Forecasting" },
      {
        text: "Medium-term Forecaster (MTF)",
        icon: "mdi-chart-timeline-variant",
        value: "medium-term-forecaster",
      },
      {
        text: "Shock Simulator (SIM)",
        icon: "mdi-pulse",
        value: "shock-simulator",
      },
      { header: "Comparative" },
      {
        text: "Comparative Country Tables (TAB)",
        icon: "mdi-table-large",
        value: "comparative-country-tables",
      },
      { header: "Data" },
      {
        text: "Weekly Database (WDB)",
        icon: "mdi-database-outline",
        value: "historical-data-visualization",
      },
      { header: "Research" },
      {
        text: "Backtesting",
        icon: "mdi-chart-line",
        value: "backtesting",
      },
      {
        text: "Trading Strategy",
        icon: "mdi-finance",
        value: "trading-strategy",
      },
      {
        text: "White Paper",
        icon: "mdi-file-document-outline",
        value: "white-paper",
      },
    ],
    items: [
      {
        icon: "mdi-account-circle",
        title: "User Profile",
      },
      {
        icon: "mdi-settings",
        title: "Logout",
      },
    ],
  }),
  watch: {
    group() {
      this.drawer = false;
    },
  },
  created() {
    // on phones the drawer is a temporary overlay: start closed
    if (useDisplay().mobile.value) this.drawer = false;
  },
  mounted() {
    this.checkAuth();
  },
  methods: {
    // highlight the drawer entry matching the current route
    isActive(value) {
      const path = this.$route.path;
      // before the first navigation resolves the route is "/" — don't flash Home
      if (!this.$route.matched.length) return false;
      if (value === "home") return path === "/" || path === "/home";
      return path === "/" + value;
    },
    ...mapActions(["logout", "checkAuth"]),
    redirectTo(value) {
      this.$router.push("/" + value);
      if (!this.hoverOne) this.drawer = false;
    },
  },
  computed: {
    getSrc: function () {
      if (this.me && this.me.avatarurl) {
        return this.me.avatarurl;
      } else {
        return this.src;
      }
    },
    getUsername: function () {
      return this.me.username;
    },
    getEmail: function () {
      return this.me.email;
    },
    ...mapState({
      me: (state) => state.auth.me,
    }),
    hoverOne: function () {
      if (useDisplay().mobile.value) {
        return false;
      }
      return true;
    },
    hoverOneRail: function () {
      if (useDisplay().mobile.value) {
        return false;
      } else {
        return this.drawer;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

.title {
  font-family: "Open Sans";
  font-size: 22px;
}
.list-title {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>